var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-list"},_vm._l((_vm.reviews),function(review){return _c('review-list-item',{key:review.id,ref:review.id,refInFor:true,attrs:{"review":review}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }